import React, { useState } from 'react'
import PropTypes from "prop-types"

const CreditCardList = ({items, onCharge, active = true}) => {
  if (!items) return null

  const renderedItems = items.map(item =>
    <tr key={item.last4}>
      <td>
        <div className='credit-cards-item'>
          { item.imageUrl ? <img src={item.imageUrl}/> : <div className={'brand-img' + ` ${item.name}-img`}></div> }
          &nbsp;&nbsp;{item.last4}
        </div>
      </td>
      <td>{item.default ? "YES" : "No"}</td>
      <td className='charge_button'>
        <button className="btn btn-xs btn-success" onClick={() => {active && onCharge(item.token)}}>Charge</button>
      </td>
    </tr>
  )
  return (
    <div className="credit-cards panel panel-default">
      <div className="panel-heading">Available Cards</div>
      <table className="table table-striped">
        <thead>
          <tr><th>Card Number</th><th>Default Card</th><th>Pay</th></tr>
        </thead>
        <tbody>
          {renderedItems}
          <tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
        </tbody>
      </table>
    </div>
  )
}

CreditCardList.propTypes = {
  items: PropTypes.array,
  onCharge: PropTypes.func,
}

export default CreditCardList
